import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { GlobalService } from "../../services/global.service";
import { StorageService } from "../../services/storage.service";
import * as SecureLS from "secure-ls";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-text-search-in-video",
  templateUrl: "./text-search-in-video.component.html",
  styleUrls: ["./text-search-in-video.component.css"],
})
export class TextSearchInVideoComponent implements OnInit {
  @Output() listClick: EventEmitter<any> = new EventEmitter();
  @ViewChildren("ce") ces: QueryList<ElementRef>;
  @ViewChild("textContent") textContent: ElementRef;
  private ls = new SecureLS({ encodingType: "aes" });
  transcriptionTextList: any;
  searchText = "";
  err: any;
  video_transcription: any;
  constructor(
    private spinner: NgxSpinnerService,
    public globalService: GlobalService,
    private storageService: StorageService,
    public router: ActivatedRoute
  ) {}

  ngOnInit(): void {
    if(this.globalService.videoTranscription){
    this.getTranscriptionText();
    }
  }
  async getTranscriptionText() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      class_room_video_details_id: this.router.snapshot.queryParams.key,
    };

    let transcriptionText = await this.globalService.get("classVideoDetail/get-video-transcription",filter,true);
    if (transcriptionText["status"] == 200) {
      this.video_transcription = transcriptionText["content"]["video_transcription"]
      this.transcriptionTextList = JSON.parse(
        this.video_transcription
      );
      this.err = null;
      this.spinner.hide();
    } else {
      this.err = transcriptionText["error"].message;
      this.spinner.hide();
    }
  }

  onTypeSearchBox(searchText) {
    if (searchText.length >= 3) {
      const regexp = new RegExp(searchText, "gi");
      this.ces.toArray()?.forEach((elem) => {
        elem.nativeElement.innerHTML = elem.nativeElement.innerText.replace(
          regexp,
          `<span class="highlight">${searchText}</span>`
        );
      });
    } else {
      this.transcriptionTextList.length = 0;
      this.transcriptionTextList = JSON.parse(
        this.video_transcription
      );
    }
  }

  onClickTranscriptionText(list) {
    this.listClick.emit(list);
  }
}
